import { useContext, useEffect ,useState} from 'react';
import { useHistory } from 'react-router';
import { UserContext } from '../lib/UserContext';
import Loading from './loading';
import { magic } from '../lib/magic';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CsvDownload from 'react-json-to-csv'
import {Alert} from 'react-bootstrap'
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));
const Home = () => {
  const [user] = useContext(UserContext);
  const history = useHistory();
  const classes = useStyles();
  const [loading,setLoading] = useState(false);
  const [products,setProducts] = useState();
  const [site,setSite] = useState()
  const [downloadReady,setDownloadReady] = useState(false);

  // If not loading and no user found, redirect to /login
  const getToken = async () =>{
    var token = await magic.user.getIdToken();
    console.log(token)
    return token;
  }
  const handleSite = (e) =>{
    setSite(e.target.value);
  }


  const getProducts = async() =>{
    setLoading(true);
    if(site && site!= undefined){
      let token = await getToken()
      let data ={
        site:site
  
      }
      let config = {
         method:'post',
         headers: {
          'Content-Type': 'application/json',
          'authorization':'Bearer ' + token
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body:JSON.stringify(data)
    
      }
      var products = await 
      fetch(process.env.REACT_APP_SERVER_URL + '/api/shopify-products',config)
      .then((data)=>data.json())
      .then(products=>{
        setProducts(products.products)
        setLoading(false);
        setDownloadReady(true);
      })
      .catch((e)=>{
        setLoading(false);
        alert(`That URL didn't work. Check it to make sure it's valid and try again`)
      })

  
    }else{
      alert('Make sure you entered a valid site')
    }
  }

  const clear = () =>{
    setProducts();
    setSite('');
    setDownloadReady(false)
  }

  useEffect(() => {
    user && !user.loading && !user.issuer && history.push('/login');
    getToken()
    // getProducts()
  }, [user, history]);
  

  return <>{user?.loading ? <Loading /> : user?.issuer && 
  
  <div>
      <Alert key={1} variant={'primary'}>
          Thanks for using Shopify Sleuth! To checkout other Shopify stores products, please enter the valid(include the https:// part of the domain) URL for the shopify store.
      </Alert>

       <form className={classes.root} noValidate autoComplete="off">
        <TextField id="standard-basic" value={site} label="Enter Shopify Store URL" onChange={handleSite}/>
      </form>
      {!loading && !downloadReady  && <Button variant="contained" color="primary" onClick={getProducts}>
      Download products
      </Button>}
    <div>
    {
      loading && <Loading/>
    }

    {
      downloadReady &&
      <CsvDownload data={products}
      
      style={{ //pass other props, like styles
        boxShadow:"inset 0px 1px 0px 0px #e184f3",
        background:"linear-gradient(to bottom, #c123de 5%, #a20dbd 100%)",
        backgroundColor:"#c123de",
        borderRadius:"6px",
        border:"1px solid #a511c0",
        display:"inline-block",
        cursor:"pointer","color":"#ffffff",
        fontSize:"15px",
        fontWeight:"bold",
        padding:"6px 24px",
        textDecoration:"none",
        textShadow:"0px 1px 0px #9b14b3"
        }}
  
> Download Products CSV</CsvDownload>

    }
    </div>
    <br/>
    <Button variant="contained" color="primary" onClick={clear}>Clear Current Site</Button>



  </div>
  

  
  }</>;
};

export default Home;
